import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { PortalContentLayout } from '@app/lib/layout/PortalContentLayout/PortalContentLayout'
import { Heading } from '@app/lib/typography/Heading/Heading'
import { CourtCaseTabNames } from '@app/modules/CourtCases'
import { useCourtCaseContext } from '@app/modules/CourtCases/Components/CourtCaseContext/CourtCaseContext'
import { CourtCaseHeader } from '@app/modules/CourtCases/Components/CourtCaseHeader/CourtCaseHeader'
import { CourtCaseInvoicingForm } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/CourtCaseInvoicingForm'
import ProfileBox from '@app/modules/Messages/Components/ProfileBox/ProfileBox'
import { NavBar } from '@app/NavBar'

import './styles.scss'
import { CourtCaseInvoiceList } from '../Components/CourtCaseInvoiceList/CourtCaseInvoiceList'

export const CourtCaseInvoicingPage = () => {
  const b = bemJoin('court-case')
  const { formatMessage } = useIntl()
  const { data, loading } = useCourtCaseContext()

  const customer = data?.customer
  const product = data?.customer.membership?.product

  return (
    <NavBar title={formatMessage({ id: 'CourtCases.Title' })}>
      <PortalContentLayout className={b()}>
        <CourtCaseHeader activeTab={CourtCaseTabNames.Invoicing} />
        <PortalContentLayout.MainPane>
          <PortalContentLayout.MainPane.Content>
            <PortalContentLayout.Container>
              <Heading color={'primary'} className={b('title')}>
                {formatMessage({ id: 'CourtCases.Invoicing.Title' })}
              </Heading>
              <CourtCaseInvoicingForm />
            </PortalContentLayout.Container>
            <PortalContentLayout.Container>
              <CourtCaseInvoiceList />
            </PortalContentLayout.Container>
          </PortalContentLayout.MainPane.Content>
          <PortalContentLayout.MainPane.Sidebar>
            {!loading && customer && product && (
              <ProfileBox
                customer={customer}
                latestPurchase={product.name}
                upgradesTo={product.upgradesTo}
              />
            )}
          </PortalContentLayout.MainPane.Sidebar>
        </PortalContentLayout.MainPane>
      </PortalContentLayout>
    </NavBar>
  )
}
